import { render } from "./CreateArrivalDeclarationModal.vue?vue&type=template&id=25bd3c24"
import script from "./CreateArrivalDeclarationModal.vue?vue&type=script&lang=js"
export * from "./CreateArrivalDeclarationModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__